import { TestConfig } from "yup/lib/util/createValidation";

import { MAX_FILE_SIZE } from "../constants/files";
import { UploadedFileWithSize } from "../types/common";

export const SWIFTPattern = /^[A-Za-z0-9/?:().,'+\-\s\n]*$/;
export const LinePattern = /^.*([\s\n].*){0,3}$/;
export const CharacterPattern = /^.{0,35}([\s\n].{0,35}){0,3}$/;

export const MinAmountLargerThanZero: TestConfig<string | undefined> = {
    name: "min-value-larger-than-zero",
    message: "Amount entered should be greater than 0",
    test: (value) => !!value && Number.parseFloat(value) > 0,
};

export const MaxTotalFileSize: TestConfig<any[] | undefined> = {
    name: "max-total-size",
    message: "Maximum file size of 50MB has been exceeded",
    test: (value) => {
        return (
            (value as UploadedFileWithSize[]).reduce(
                (acc, cur) => acc + (cur.size || 0),
                0,
            ) < MAX_FILE_SIZE
        );
    },
};
